import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Sarah Jenkins',
  role: '',
  text: 'Mike completely transformed our online presence. We went from a clunky, outdated site to a sleek, modern platform that actually brings in new gym members every week. His communication was flawless.',
  rating: 5
}, {
  name: 'David Chen',
  role: '',
  text: 'Working directly with the owner makes a huge difference. Mike understood our complex B2B needs and delivered a blazing fast site. No agency runaround, just pure results and professionalism.',
  rating: 5
}, {
  name: 'Marcus Thorne',
  role: '',
  text: 'The attention to detail is unmatched. Mike built us a custom property listing system that our agents love. It was delivered on time and on budget. Highly recommend his services.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-24 bg-[#0A0A0F] relative" data-id="element-321">
      <div className="container mx-auto px-6 md:px-12" data-id="element-322">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-323">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-324">
            Client <span className="text-gradient" data-id="element-325">Success Stories</span>
          </h2>
          <p className="text-lg text-[#FFFFFF]" data-id="element-326">
            Don't just take my word for it. Here's what business owners have to
            say about working with Mike's Pro Web Design.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-327">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#111118] border border-white/5 rounded-2xl p-8 relative" data-id="element-328">
              <div className="flex gap-1 mb-6" data-id="element-329">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={18} className="fill-blue-500 text-blue-500" data-id="element-330" />)}
              </div>

              <p className="leading-relaxed mb-8 relative z-10 text-[#FFFFFF]" data-id="element-331">
                "{review.text}"
              </p>

              <div className="flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-332">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center text-white font-bold text-lg" data-id="element-333">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-334">
                  <h4 className="text-white font-bold" data-id="element-335">{review.name}</h4>
                  <p className="text-sm text-[#FFFFFF]" data-id="element-336">{review.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}